import { PlanCategoryEnum } from 'plan-library-common'

import { groupFieldsEnum } from './constants'

export const ALL_MULTI_FAMILY_PLANS = '/multi-family'
export const PLAN_SHARE = '/user/share'
export const PLAN = '/plan'
export const SHELL = '/shell'
export const SHELL_HISTORY = '/shell/history'
export const SHELL_CHECK_SHELL_EXISTS = '/shell/check-shell-exists'
export const PLAN_CHECK_PLAN_EXISTS_BY_ID = (planId: string) => {
  return `/plan/${planId}/exists`
}
export const UNIT = '/unit'
export const UNIT_HISTORY = '/unit/history'
export const UNIT_CHECK_UNIT_EXISTS = '/unit/check-unit-exists'
export const PLAN_DELETE = '/plan/delete'
export const LOAD_PDF_DELETE = '/load-pdf/delete'
export const SHELL_DELETE_PDF = '/load-pdf/shell/delete'
export const UNIT_DELETE_PDF = '/load-pdf/unit/delete'
export const PLAN_RENAME_FILE = '/plan/rename-file'
export const SHELL_RENAME_FILE = '/shell/rename-file'
export const UNIT_RENAME_FILE = '/unit/rename-file'
export const PLAN_SAVE_DRAFT = '/plan/save-draft'
export const SHELL_SAVE_DRAFT = '/shell/draft'
export const UNIT_SAVE_DRAFT = '/unit/draft'
export const LOAD_PDF_DOWNLOAD = '/load-pdf/download'
export const USER_PLAN_FAVORITE = '/user/plan/favorite'
export const USER_PLAN_FAVORITES = '/user/plan/favorites'
export const USER_PLAN_REMOVE_FAVORITE = '/user/plan/remove-favorite'
export const USER_BASE_PLAN_FAVORITE = '/user/base-plan/favorite'
export const USER_BASE_PLAN_UNFAVORITE = '/user/base-plan/unfavorite'
export const USER_BASE_PLAN_ALL_FAVORITES = '/user/base-plan/all-favorites'
export const PLAN_ALL_COMMUNITY_PLANS = '/plan/all-community-plans'
export const PLAN_AUTO_EXTRACTED_PLANS = '/plan/auto-extracted-plans'
export const PLAN_CONFIRM_PENDING_PLAN = '/plan/confirm-pending-plan'
export const MULTI_FAMILY_CONFIRM_PENDING_PLAN =
  '/multi-family/confirm-pending-plan'
export const PLANS_FILTERED = '/plans/filtered'
export const UNITS_FILTERED = '/unit/filtered'
export const SHELLS_FILTERED = '/shell/filtered'
export const PLANS_FILTERED_BULK_EXPORT = '/plans/filtered/bulk-export'
export const UNITS_FILTERED_BULK_EXPORT = '/unit/filtered/bulk-export'
export const SHELLS_FILTERED_BULK_EXPORT = '/shell/filtered/bulk-export'
export const USER_PLANS_SHARED_WITH_ME = '/user/plans-shared-with-me'
export const JDE_PRICE_STATUS = '/jde/plan/price-status'
export const COMMUNITY = '/community'
export const USER_DASHBOARD = '/user/dashboard'
export const LOAD_PDF_UPLOAD = '/load-pdf/upload'
export const LOAD_PDF_UPLOAD_FOR_AUTO_EXTRACT =
  '/load-pdf/upload-for-auto-extract'
export const UPLOAD_SHELL_PDF = '/load-pdf/shell/upload'
export const UPLOAD_UNIT_PDF = '/load-pdf/unit/upload'
export const CORE_PLAN_FILE_UPLOAD = '/core-plan-files/upload'
export const CORE_PLAN_FILE_DELETE = '/core-plan-files/delete'
export const CORE_PLAN_FILE_IMAGES = '/core-plan-files/images'
export const PLAN_COPY_MANY_TO_ONE_COMMUNITY =
  '/plan/copy-many-to-one-community'
export const MULTI_FAMILY_COPY_MANY_TO_ONE_COMMUNITY =
  '/multi-family/copy-many-to-one-community'
export const SHELL_PROPAGATE_CHANGES = '/shell/propagate-changes'
export const UNIT_PROPAGATE_CHANGES = '/unit/propagate-changes'
export const PROPAGATE_CHANGES = '/plan/propagate-changes'
export const PLAN_BULK_EXPORT_PLANS = '/load-pdf/export'
export const PLAN_BULK_EXPORT_PLANS_STATUS = '/load-pdf/exportStatus'
export const PLAN_BULK_EXPORT_PLANS_DOWNLOAD = '/load-pdf/export/download'
export const PLAN_BULK_EXPORT_APPROVALS_HISTORY_REPORT =
  '/load-pdf/export/approval-history-report'
export const USER_USER_UUID = '/user/uuid'
export const ADMIN = '/admins'
export const GET_APPROVALS = '/admins/approvals'
export const LOAD_PDF_COPY_FILE = '/load-pdf/copy'
export const CHECK_DOCUMENT_CORRUPTION = '/load-pdf/file-exists'
export const IMAGES = '/images'
export const IMAGES_DOWNLOAD = '/images/download'
export const VIRTUAL_TOURS = '/virtual-tours'
export const GET_FILTERED_PLAN_DETAILS = (
  basePlanId: string,
  plan: string,
  planCategory: PlanCategoryEnum,
  groupBy: groupFieldsEnum,
  division: string | undefined
) => {
  let url = `/plans/${basePlanId}/${plan}/${planCategory}/${groupBy}/filtered`
  if (division !== undefined && division !== '') {
    url += `?division=${division}`
  }
  return url
}
export const GET_FILTERED_MULTI_FAMILY_DETAILS = (
  classType: string,
  basePlanId: string,
  plan: string,
  planCategory: PlanCategoryEnum,
  groupBy: groupFieldsEnum,
  division: string | undefined
) => {
  let url = `/multi-family/${classType}/${basePlanId}/${plan}/${planCategory}/${groupBy}/filtered`
  if (division !== undefined && division !== '') {
    url += `?division=${division}`
  }
  return url
}
export const GET_MODSY_SPECS = (communityId: string) => {
  return `/modsy/community-spec-data/${communityId}`
}
export const UPDATE_PLAN_ATTRIBUTES = (communityPlanId: string) => {
  return `/plans/${communityPlanId}`
}
export const UPDATE_SHELL_PLAN_ATTRIBUTES = (id: string) => {
  return `/shell/${id}`
}
export const UPDATE_UNIT_PLAN_ATTRIBUTES = (id: string) => {
  return `/unit/${id}`
}
export const REQUEST_TO_COPY_PLAN = (communityPlanId: string) => {
  return `/admins/${communityPlanId}/approvals`
}
export const GET_IS_APPROVER = () => {
  return `/admins/is-approver`
}
export const GET_REGIONAL_APPROVALS = '/admins/regional-approvals'
export const REQUEST_REGIONAL_APPROVAL = (draftPlanId: string) => {
  return `/admins/${draftPlanId}/regional-approvals`
}
export const REGIONAL_APPROVAL_BY_ID = (id: string) => {
  return `/admins/regional-approvals/${id}`
}
export const REGIONAL_APPROVAL_RELINK = (id: string) => {
  return `/admins/regional-approvals/${id}/relink`
}
export const REQUEST_NEW_REGIONAL_ELEVATION =
  '/admins/regional-approvals/new-elevation'
export const SHELL_DELETE = (planId: string) => {
  return `/shell/${planId}`
}
export const UNIT_DELETE = (planId: string) => {
  return `/unit/${planId}`
}
export const PLAN_COPY_APPROVAL = (communityPlanId: string) => {
  return `/admins/${communityPlanId}/approvals`
}

export const GET_ADMIN_UPLOAD_TEMPLATE = '/load-pdf/admin-upload-template'

export const GET_ADMIN_UPLOAD_TEMPLATE_LAST_MODIFIED_DATE_TIME =
  '/load-pdf/template-file-last-modified-date-time'

export const RELEASE_NOTES_PDF_VERSIONS = '/load-pdf/release-notes-pdf-versions'

export const RELEASE_NOTES_PDF_BY_VERSION = (releaseVersion: string) => {
  return `/load-pdf/download-pdf-by-version/${releaseVersion}`
}
